module.exports = {
	"cases": [
		{
			"behance": "https://www.behance.net/gallery/30977665/Hotsite-Grandes-Historias-Colgio-Uirapuru",
			"bg_box": "bg_case_grandeshistorias",
			"logo": "./src/assets/images/cases/logos/uirapuru.png",
			"alt": "Colégio Uirapuru",
			"name": "Colégio Uirapuru",
			"description": {
				"pt-BR": "Grandes histórias começam aqui",
				"en-US": "Great stories start here"
			},
			"background": "./src/assets/images/cases/bg/grandeshistorias-bg.jpg"
		},
		{
			"behance": "https://www.behance.net/gallery/33450277/Website-FLIR-Building-Store",
			"bg_box": "bg_case_building",
			"logo": "./src/assets/images/cases/logos/flir.png",
			"alt": "FLIR Systems",
			"name": "FLIR - Building Store",
			"description": {
				"pt-BR": "A melhor solução estrutural",
				"en-US": "The best structural solution"
			},
			"background": "./src/assets/images/cases/bg/building-bg.jpg"
		},
		{
			"behance": "https://www.behance.net/gallery/37291701/Website-Personal-College",
			"bg_box": "bg_case_personalcollege",
			"logo": "./src/assets/images/cases/logos/personal-college.png",
			"alt": "Personal College",
			"name": "Personal College",
			"description": {
				"pt-BR": "Plataforma de conhecimento",
				"en-US": "Knowledge platform"
			},
			"background": "./src/assets/images/cases/bg/personal-bg.jpg"
		},
		{
			"behance": "http://onganize.com.br/",
			"bg_box": "bg_case_onganize",
			"logo": "./src/assets/images/cases/logos/onganize.png",
			"alt": "Onganize",
			"name": "Onganize",
			"description": {
				"pt-BR": "Sistema Financeiro",
				"en-US": "Financial System"
			},
			"background": "./src/assets/images/cases/bg/onganize-bg.jpg"
		},
		{
			"behance": "https://www.behance.net/gallery/28991499/Website-OUTLABEL",
			"bg_box": "bg_case_outlabel",
			"logo": "./src/assets/images/cases/logos/outlabel.png",
			"alt": "Outlabel",
			"name": "Outlabel",
			"description": {
				"pt-BR": "Site com produção de fotos e vídeo",
				"en-US": "Site and production of photos and video"
			},
			"background": "./src/assets/images/cases/bg/outlabel-bg.jpg"
		},
		{
			"behance": "https://www.behance.net/gallery/29165463/Website-Magic-Beans",
			"bg_box": "bg_case_magicbeans",
			"logo": "./src/assets/images/cases/logos/magic-beans.png",
			"alt": "Magic Beans",
			"name": "Magic Beans",
			"description": {
				"pt-BR": "Alimentando a esperança do Haiti",
				"en-US": "Feeding hope Haiti"
			},
			"background": "./src/assets/images/cases/bg/magicbeans-bg.jpg"
		},
		{
			"behance": "https://www.behance.net/gallery/30717627/Website-Intercambio-de-Sucesso",
			"bg_box": "bg_case_intercambio",
			"logo": "./src/assets/images/cases/logos/intercambio-de-sucesso.png",
			"alt": "Intercâmbio de Sucesso",
			"name": "Intercâmbio de Sucesso",
			"description": {
				"pt-BR": "Prepare suas malas e mude sua vida",
				"en-US": "Prepare your bags and change your life"
			},
			"background": "./src/assets/images/cases/bg/intercambio-bg.jpg"
		},
		{
			"behance": "http://pumpmylead.com/",
			"bg_box": "bg_case_pump",
			"logo": "./src/assets/images/cases/logos/pump-my-lead.png",
			"alt": "Pump My Lead",
			"name": "Pump My Lead",
			"description": {
				"pt-BR": "Sistema de Gerenciamento de Leads",
				"en-US": "Leads Management System"
			},
			"background": "./src/assets/images/cases/bg/pump-bg.jpg"
		},
		{
			"behance": "http://transparenciasocial.com.br/",
			"bg_box": "bg_case_transparencia",
			"logo": "./src/assets/images/cases/logos/transparencia-social.png",
			"alt": "Transparência Social",
			"name": "Transparência Social",
			"description": {
				"pt-BR": "Conectando pessoas e causas",
				"en-US": "Connecting people and causes"
			},
			"background": "./src/assets/images/cases/bg/transparencia-bg.jpg"
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/data/cases.json
// module id = 62
// module chunks = 0